// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:58:46

export default {
  "id": "spider-evolution",
  "slug": "spider-evolution",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/346f12abed0944c8acb1fe037f92de3f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/346f12abed0944c8acb1fe037f92de3f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Spider Evolution",
      "description": "Transform into the ultimate spider in Spider Evolution! Start small, grow stronger, and outsmart rivals on a vibrant track. Merge, dodge, and strategize to become the apex arachnid. Experience thrilling hyper-casual gameplay and dominate the spider world!",
      "instructions": "Keyboard arrow keys or A D keys to control player to move left or right, or use mouse control with right slider or left slide.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "animal",
        "arcade",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "蜘蛛进化",
      "description": "化身成为蜘蛛进化的终极形态！从小开始，变得更强，在一个充满活力的赛道上智胜对手。合并、躲避、策略，成为顶级蜘蛛。体验令人兴奋的超休闲游戏玩法，统治蜘蛛世界！",
      "instructions": "键盘方向键或A D键控制玩家左右移动，或使用鼠标控制，右滑块或左滑。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "动物",
        "街机",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "蜘蛛進化",
      "description": "化為蜘蛛進化的最終強者！從小開始，變得更強大，並在色彩繽紛的跑道上智勝敵手。合體、躲避、策劃，成為至高無上的蜘蛛。體驗驚險的超簡單遊戲，佔領蜘蛛世界！",
      "instructions": "按鍵盤方向鍵或 A D 鍵控制玩家左右移動，或使用滑鼠控制，右滑桿為向右滑，左滑桿為向左滑。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "動物",
        "電子遊戲",
        "跑酷"
      ]
    },
    "zh-HK": {
      "title": "蜘蛛進化",
      "description": "變身為至高無上的蜘蛛！在蜘蛛進化中開始小，變得更強壯，並在色彩繽紛的跑道上智取對手。合併、閃避及策略規劃，成為頂尖的蜘蛛。體驗刺激的極速輕鬆遊戲，佔領蜘蛛世界！",
      "instructions": "按鍵盤方向鍵或 A D 鍵控制角色左右移動，或使用滑鼠控制右滑桿或左滑桿。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "動物",
        "街機",
        "跑酷"
      ]
    },
    "ja": {
      "title": "スパイダー進化",
      "description": "スパイダー進化で究極のスパイダーに変身せよ！小さくて強く、鮮やかなトラックでライバルを智略で倒していく。合体し、回避し、戦略を練って頂点のクモとなる。スリル満点のハイパーカジュアルゲームプレイを体験し、スパイダーの世界を支配せよ！",
      "instructions": "キーボードの矢印キーまたはA Dキーでプレイヤーを左右に移動させ、または右スライダーや左スライドを使用してマウス操作を行います。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "動物",
        "アーケード",
        "ランナー"
      ]
    },
    "ko": {
      "title": "스파이더 진화",
      "description": "스파이더 에볼루션에서 최고의 스파이더로 변신하세요! 작게 시작해 강해지고, 화려한 트랙에서 라이벌들을 이기세요. 합쳐지고, 피해가고, 전략을 세워 최상위 아라키드가 되세요. 흥미진진한 하이퍼 캐슐 게임을 경험하고 스파이더 세계를 지배하세요!",
      "instructions": "키보드 아래 방향키나 A D 키를 눌러 플레이어를 왼쪽 또는 오른쪽으로 이동시키거나, 마우스를 사용하여 오른쪽 슬라이더나 왼쪽 슬라이드로 제어하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "동물",
        "아케이드",
        "러너"
      ]
    },
    "fr": {
      "title": "Évolution de l'Araignée",
      "description": "Transformez-vous en le spider ultime dans Spider Evolution ! Commencez petit, devenez plus fort et éliminez vos rivaux sur une piste vibrante. Fusionnez, évitez et stratégisez pour devenir l'arachnide suprême. Profitez de gameplay hyper-casual épique et dominez le monde des spiders !",
      "instructions": "Touches flèches du clavier ou touches A D pour contrôler le joueur et le déplacer à gauche ou à droite, ou utiliser le contrôle de la souris avec le curseur droit ou le curseur gauche.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "animal",
        "arcade,runner"
      ]
    }
  }
};
